export const useExercisesChapterProgressions = (
  allProgressions: Ref<ProgressionSchema[]>,
  ids: Ref<string[]>
) => {
  const progressions = computed(() => {
    if (!allProgressions.value) return [];
    return allProgressions.value.filter((progression) =>
      ids.value.includes(progression.contentId)
    );
  });

  const exercisesCount = computed(() => ids.value.length);

  const exercisesDoneCount = computed(() => {
    const total = ids.value.length;
    if (total === 0) return -1;
    if (!progressions.value) return 0;
    return progressions.value.reduce((acc, progression) => {
      const data = progression.data as ExerciseDetailsProgression;
      if (data.status === 'done') return acc + 1;
      return acc;
    }, 0);
  });

  const progress = computed(() => {
    if (exercisesCount.value === 0) return 0;
    return exercisesDoneCount.value / exercisesCount.value;
  });

  const score = computed(() => {
    const total = ids.value.length;
    if (total === 0) return 0;
    if (!progressions.value) return 0;

    const score = progressions.value.reduce((score, progression) => {
      const data = progression.data as ExerciseDetailsProgression;
      const sc = data.points / data.maxPoints;
      score += sc;
      return score;
    }, 0);
    return score / total;
  });

  const scoreOn20 = computed(() => getScoreOn20(score.value));

  const isCompleted = computed(() => {
    return exercisesDoneCount.value === exercisesCount.value;
  });

  return {
    exercisesCount,
    exercisesDoneCount,
    progress,
    score,
    scoreOn20,
    isCompleted,
  };
};
